import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
import { MeasurementUnit } from '@square/dashboard-protos/models/squareup/connect/v2/common/measurement_units';
export const Area = new Enum(['INVALID_AREA', 'IMPERIAL_SQUARE_INCH', 'METRIC_SQUARE_CENTIMETER', 'METRIC_SQUARE_METER', 'IMPERIAL_ACRE', 'IMPERIAL_SQUARE_FOOT', 'IMPERIAL_SQUARE_YARD', 'IMPERIAL_SQUARE_MILE', 'METRIC_SQUARE_KILOMETER']);
export const Length = new Enum(['INVALID_LENGTH', 'IMPERIAL_INCH', 'METRIC_MILLIMETER', 'METRIC_METER', 'IMPERIAL_FOOT', 'IMPERIAL_YARD', 'IMPERIAL_MILE', 'METRIC_CENTIMETER', 'METRIC_KILOMETER']);
export const Volume = new Enum(['INVALID_VOLUME', 'GENERIC_FLUID_OUNCE', 'METRIC_MILLILITER', 'METRIC_LITER', 'GENERIC_SHOT', 'GENERIC_CUP', 'GENERIC_PINT', 'GENERIC_QUART', 'GENERIC_GALLON', 'IMPERIAL_CUBIC_INCH', 'IMPERIAL_CUBIC_FOOT', 'IMPERIAL_CUBIC_YARD']);
export const Weight = new Enum(['INVALID_WEIGHT', 'IMPERIAL_WEIGHT_OUNCE', 'METRIC_MILLIGRAM', 'METRIC_GRAM', 'METRIC_KILOGRAM', 'IMPERIAL_POUND', 'IMPERIAL_STONE']);
export const Time = new Enum(['INVALID_TIME', 'GENERIC_MILLISECOND', 'GENERIC_SECOND', 'GENERIC_MINUTE', 'GENERIC_HOUR', 'GENERIC_DAY']);
export const Generic = new Enum(['INVALID_GENERIC_UNIT', 'UNIT']);
export const Custom = ProtoBaseModel.extend({
  name: attr(String),
  abbreviation: attr(String)
});
export default ProtoBaseModel.extend({
  customUnit: attr(Custom),
  areaUnit: attr(Area),
  lengthUnit: attr(Length),
  volumeUnit: attr(Volume),
  weightUnit: attr(Weight),
  timeUnit: attr(Time),
  genericUnit: attr(Generic)
}).reopenClass({
  fromProto(proto) {
    if (!proto) {
      return null;
    }
    let areaUnit, genericUnit, lengthUnit, timeUnit, volumeUnit, weightUnit;
    if (proto.areaUnit) {
      areaUnit = MeasurementUnit.Area[proto.areaUnit];
    }
    if (proto.genericUnit) {
      genericUnit = MeasurementUnit.Generic[proto.genericUnit];
    }
    if (proto.lengthUnit) {
      lengthUnit = MeasurementUnit.Length[proto.lengthUnit];
    }
    if (proto.volumeUnit) {
      volumeUnit = MeasurementUnit.Volume[proto.volumeUnit];
    }
    if (proto.weightUnit) {
      weightUnit = MeasurementUnit.Weight[proto.weightUnit];
    }
    if (proto.timeUnit) {
      timeUnit = MeasurementUnit.Time[proto.timeUnit];
    }
    return this.create({
      customUnit: proto.customUnit,
      areaUnit,
      genericUnit,
      lengthUnit,
      volumeUnit,
      weightUnit,
      timeUnit
    });
  }
});